/* global axios */
import ApiClient from './ApiClient';

class AiProviderStatusAPI extends ApiClient {
  constructor() {
    super('ai_provider_status', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new AiProviderStatusAPI();
